import React from 'react';
import { TextInput, required, SelectInput } from 'react-admin';
import { Grid } from '@material-ui/core/';
import DateInput from '../../core/components/forked/input/DateInput';
import { fundTermStatus } from './FundTermsLookup';
import RichTextInput from '../../core/components/inputs/RichTextInput';
import { Typography } from '@material-ui/core';
import { isValidDate, formatDate } from '../../core/utils/index';

const FundTermsSummary = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <Typography variant="h5">Details</Typography>
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <TextInput
          source="name"
          label="Fund Term Name"
          validate={[required()]}
          options={{ autoComplete: 'off' }}
          variant="standard"
          autoFocus
          helperText={false}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <DateInput
          source="startDate"
          label="Start Date"
          validate={[required(), isValidDate]}
          options={{ autoComplete: 'off' }}
          variant="standard"
          helperText={false}
          placeholder="MM/dd/yyyy"
          customParseValue={formatDate}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <SelectInput
          source="activeVersion"
          label="Status"
          choices={fundTermStatus}
          validate={[required()]}
          variant="standard"
          helperText={false}
        />
      </Grid>
      <Grid item xs={12}>
        <RichTextInput
          source="termsCopy"
          label="Content"
          displayingVariables={false}
        />
      </Grid>
    </Grid>
  );
};

export default FundTermsSummary;
